import { createGlobalStyle } from 'styled-components';
import { token } from '@bynder/design-system';

import { TEXT } from '../../../constants/styles';

export const GlobalStyle = createGlobalStyle`
  body {
    background-color: ${token.white};
    padding: 0;
  }

  #root {
    background-color: ${token.white};
    min-height: auto;
    height: auto;
  }

  body, h1, h2, h3, h4, h5, h6, p {
    font-family: ${TEXT.FONT_FAMILY};
    font-weight: ${TEXT.FONT_WEIGHT};
    color: ${token.colorText};
    text-transform: none;
  }

  .tooltip {
    pointer-events: none;
  }

  // hide arrow from tooltips
  .tooltip-arrow {
    display: none;
  }

  ::selection {
    background: ${token.gray200a};
  }

  ::-moz-selection {
    background: ${token.gray200a};
  }

  // Pybynder Header related styles
  header.base nav.navbar-primary {
    #navmain-dropdown .dropdown-list li a {
      width: inherit;
    }
  }

  /**
 * COLOURS
 */
/**
 * TEXT
 */
/**
 * VISUALS
 */
/* ==========================================================================
   Helper classes
   ========================================================================== */
.float-right,
.u-fr {
  float: right; }

.float-left,
.u-fl {
  float: left; }

.list-inline > li {
  display: inline-block;
  margin-right: 10px; }
  .list-inline > li:last-of-type {
    margin-right: 0; }

.list-inline--sm > li {
  margin-right: 8px; }

.list-inline--lg > li {
  margin-right: 15px; }

.text-slate {
  color: #7E8890; }

.text-center {
  text-align: center; }

.u-justified {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between; }

.u-centered {
  display: flex;
  justify-content: center; }

.u-flex {
  display: flex; }

/*
 * Disable scroll with overflow hidden
 */
.overflowhidden {
  overflow: hidden; }

.overflow-x {
  overflow-x: hidden; }

.u-scroll-v {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: -ms-autohiding-scrollbar; }

.overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  width: 100%;
  height: 100%;
  background: rgba(0, 34, 51, 0.2); }
  .overlay.fade {
    transition: opacity 0.15s linear;
    opacity: 0; }
  .overlay.fade.in {
    opacity: 1; }

.affix {
  position: fixed; }

@keyframes spinner {
  to {
    transform: rotate(360deg); } }

/*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */
/**
 * Prevent iOS and IE text size adjust after device orientation change,
 * without disabling user zoom.
 */
html {
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
  font-size: 62.5%; }

/**
   * Remove default margin.
   */
body {
  margin: 0; }

/**
   * Make sure paddings aren't added to with and height
   */
* {
  box-sizing: border-box; }


article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
main,
menu,
nav,
section,
summary {
  display: block; }


audio,
canvas,
progress,
video {
  display: inline-block;
  /* 1 */
  vertical-align: baseline;
  /* 2 */ }


audio:not([controls]) {
  display: none;
  height: 0; }


[hidden],
template {
  display: none; }

/* Links
     ========================================================================== */
/**
   * Remove the gray background color from active links in IE 10.
   */
a {
  background-color: transparent; }

/**
   * Improve readability of focused elements when they are also in an
   * active/hover state.
   */
a:active,
a:hover {
  outline: 0; }

/* Text-level semantics
     ========================================================================== */
/**
   * Address styling not present in IE 8/9/10/11, Safari, and Chrome.
   */
abbr[title] {
  border-bottom: 1px dotted; }


b,
strong {
  font-weight: bold; }

/**
   * Address styling not present in Safari and Chrome.
   */
dfn {
  font-style: italic; }


h1 {
  font-size: 2em;
  margin: 0.67em 0; }

/**
   * Address styling not present in IE 8/9.
   */
mark {
  background: #ff0;
  color: #000; }

/**
   * Address inconsistent and variable font size in all browsers.
   */
small {
  font-size: 80%; }

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline; }

sup {
  top: -0.5em; }

sub {
  bottom: -0.25em; }

/* Embedded content
     ========================================================================== */

img {
  border: 0; }

/**
   * Correct overflow not hidden in IE 9/10/11.
   */
svg:not(:root) {
  overflow: hidden; }

/* Grouping content
     ========================================================================== */
/**
   * Address margin not present in IE 8/9 and Safari.
   */
figure {
  margin: 1em 40px; }

/**
   * Address differences between Firefox and other browsers.
   */
hr {
  box-sizing: content-box;
  height: 0; }

/**
   * Contain overflow in all browsers.
   */
pre {
  overflow: auto; }


code,
kbd,
pre,
samp {
  font-family: monospace, monospace;
  font-size: 1em; }


button,
input,
optgroup,
select,
textarea {
  color: inherit;
  /* 1 */
  font: inherit;
  /* 2 */
  margin: 0;
  /* 3 */ }


button {
  overflow: visible; }


button,
select {
  text-transform: none; }


button,
html input[type="button"],
input[type="reset"],
input[type="submit"] {
  -webkit-appearance: button;
  /* 2 */
  cursor: pointer;
  /* 3 */ }

/**
   * Re-set default cursor for disabled elements.
   */
button[disabled],
html input[disabled] {
  cursor: default; }

/**
   * Remove inner padding and border in Firefox 4+.
   */
button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0; }


input {
  line-height: normal; }


input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  height: auto; }


input[type="search"] {
  -webkit-appearance: textfield;
  /* 1 */
  box-sizing: border-box;
  /* 2 */ }


input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none; }

/**
   * Define consistent border, margin, and padding.
   */
fieldset {
  border: 1px solid #c0c0c0;
  margin: 0 2px;
  padding: 0.35em 0.625em 0.75em; }


legend {
  border: 0;
  /* 1 */
  padding: 0;
  /* 2 */ }

/**
   * Remove default vertical scrollbar in IE 8/9/10/11.
   */
textarea {
  overflow: auto; }


optgroup {
  font-weight: bold; }

/* Tables
     ========================================================================== */
/**
   * Remove most spacing between table cells.
   */
table {
  border-collapse: collapse;
  border-spacing: 0; }

td,
th {
  padding: 0; }

/*
   * Remove the gap between audio, canvas, iframes,
   * images, videos and the bottom of their containers:
   * https://github.com/h5bp/html5-boilerplate/issues/440
   */
audio,
canvas,
iframe,
img,
svg,
video {
  vertical-align: middle; }

/*
   * Remove default fieldset styles.
   */
fieldset {
  border: 0;
  margin: 0;
  padding: 0; }

/*
   * Allow only vertical resizing of textareas.
   */
textarea {
  resize: vertical; }

body {
  height: 100%;
  font-family: "Source Sans Pro", arial !important;
  font-size: 62.5%;
  color: rgba(0, 34, 51, 0.8);
  -webkit-font-smoothing: subpixel-antialiased;
  -moz-osx-font-smoothing: grayscale; }

body {
  font-size: 1.6rem;
  line-height: 1.42857143; }

h1,
.alpha {
  margin: 0;
  font-size: 2rem;
  font-weight: 600; }

p {
  margin: 0; }

ul {
  margin: 0;
  padding: 0; }
  ul li {
    list-style: none; }

a,
button {
  text-decoration: none; }
  a:hover,
  button:hover {
    color: rgba(0, 34, 51, 0.8); }
  a.link--primary,
  button.link--primary {
    color: #0af; }
    a.link--primary:hover,
    button.link--primary:hover {
      color: #0088cc; }

input,
textarea,
button,
a {
  transition: 0.1s color ease, 0.1s background ease, 0.1s border-color ease; }

::-webkit-input-placeholder,
:-moz-placeholder,
::-moz-placeholder,
:-ms-input-placeholder {
  color: rgba(0, 34, 51, 0.3); }

select:invalid {
  color: rgba(0, 34, 51, 0.5); }

.material-icons {
  vertical-align: middle; }
  .material-icons--lg {
    font-size: 48px; }

.font-weight-normal {
  font-weight: normal; }

.alpha-text-size {
  font-size: 2rem; }

.beta-text-size {
  font-size: 1.8rem; }

.gamma-text-size {
  font-size: 1.6rem; }

.delta-text-size {
  font-size: 1.4rem; }

.guides__content--preview .inline-draft .DraftEditor-root {
  width: 100%; }

.disabled-draft .DraftEditor-root .public-DraftEditorPlaceholder-root {
  display: none; }

.disabled-draft .DraftEditor-root .public-DraftEditor-content:hover {
  background-color: initial; }

.public-DraftEditor-content[contenteditable='false']:hover {
  background-color: initial; }

.public-DraftStyleDefault-block {
  margin: 0 !important;
  min-width: 20px; }

.rdw-editor-main {
  overflow: visible !important; }

.rdw-link-modal {
  height: auto !important; }

.public-DraftStyleDefault-ol {
  margin: 0 !important; }
  .public-DraftStyleDefault-ol .public-DraftStyleDefault-depth0.public-DraftStyleDefault-listLTR {
    margin-left: 2.5em; }

.public-DraftStyleDefault-ltr {
  word-break: break-word;
  text-align: inherit !important; }

.rdw-link-decorator-wrapper > a {
  text-decoration: underline; }
  .rdw-link-decorator-wrapper > a > span[style] {
    text-decoration: inherit; }

@media (min-width: 768px) {
  .widget-list--preview li .public-DraftEditor-content {
    padding: 12px 0; } }

.editor-wrapper {
  position: relative;
  display: flex;
  flex-direction: column; }
  .editor-wrapper div ul li {
    list-style: none !important; }
  .editor-wrapper .editor-toolbar {
    align-self: center;
    position: absolute;
    transform: translateY(calc(-100% - 5px));
    background-color: #002233;
    box-shadow: 0 2px 10px 0 rgba(0, 34, 51, 0.1);
    border: solid 1px rgba(0, 34, 51, 0.1);
    border-radius: 5px;
    z-index: 1; }
    .editor-wrapper .editor-toolbar .rdw-block-dropdown {
      background-color: #002233;
      color: rgba(255, 255, 255, 0.8);
      border: 0;
      width: auto; }
      .editor-wrapper .editor-toolbar .rdw-block-dropdown:hover {
        box-shadow: unset; }
        .editor-wrapper .editor-toolbar .rdw-block-dropdown:hover > a span {
          color: white; }
        .editor-wrapper .editor-toolbar .rdw-block-dropdown:hover .rdw-dropdown-carettoopen,
        .editor-wrapper .editor-toolbar .rdw-block-dropdown:hover .rdw-dropdown-carettoclose {
          border-top-color: #fff !important; }
      .editor-wrapper .editor-toolbar .rdw-block-dropdown .rdw-dropdown-selectedtext span {
        font-size: 16px;
        margin-right: 4px;
        color: rgba(255, 255, 255, 0.8); }
      .editor-wrapper .editor-toolbar .rdw-block-dropdown .rdw-dropdown-selectedtext .rdw-dropdown-carettoclose,
      .editor-wrapper .editor-toolbar .rdw-block-dropdown .rdw-dropdown-selectedtext .rdw-dropdown-carettoopen {
        position: initial;
        border-top-color: rgba(255, 255, 255, 0.8);
        margin: 0 7px; }
      .editor-wrapper .editor-toolbar .rdw-block-dropdown .rdw-dropdown-selectedtext .rdw-dropdown-carettoclose {
        border-top: 6px solid rgba(255, 255, 255, 0.8);
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-bottom: transparent; }
      .editor-wrapper .editor-toolbar .rdw-block-dropdown .rdw-dropdown-optionwrapper {
        background: #002233;
        border-radius: 5px;
        border: 0;
        position: absolute;
        left: -1px;
        top: 49px;
        width: 221px;
        box-shadow: 0 2px 10px 0 rgba(0, 34, 51, 0.1); }
        .editor-wrapper .editor-toolbar .rdw-block-dropdown .rdw-dropdown-optionwrapper li:first-child {
          margin-top: 8px;
          font-size: 16px; }
        .editor-wrapper .editor-toolbar .rdw-block-dropdown .rdw-dropdown-optionwrapper li:nth-child(2) {
          font-size: 24px; }
        .editor-wrapper .editor-toolbar .rdw-block-dropdown .rdw-dropdown-optionwrapper li:nth-child(3) {
          font-size: 20px; }
        .editor-wrapper .editor-toolbar .rdw-block-dropdown .rdw-dropdown-optionwrapper li:last-child {
          margin-bottom: 8px;
          font-size: 14px; }
        .editor-wrapper .editor-toolbar .rdw-block-dropdown .rdw-dropdown-optionwrapper .rdw-dropdownoption-default {
          color: rgba(255, 255, 255, 0.5);
          min-height: 32px;
          padding: 6px 0 6px 16px; }
        .editor-wrapper .editor-toolbar .rdw-block-dropdown .rdw-dropdown-optionwrapper .rdw-dropdownoption-highlighted {
          background-color: rgba(255, 255, 255, 0.2); }
          .editor-wrapper .editor-toolbar .rdw-block-dropdown .rdw-dropdown-optionwrapper .rdw-dropdownoption-highlighted:hover {
            color: #fff; }
        .editor-wrapper .editor-toolbar .rdw-block-dropdown .rdw-dropdown-optionwrapper .rdw-dropdownoption-active {
          color: white;
          background-color: #002233; }
          .editor-wrapper .editor-toolbar .rdw-block-dropdown .rdw-dropdown-optionwrapper .rdw-dropdownoption-active:hover {
            background-color: rgba(255, 255, 255, 0.2); }
        .editor-wrapper .editor-toolbar .rdw-block-dropdown .rdw-dropdown-optionwrapper .rdw-dropdownoption-active::after {
          font-family: 'Material Icons';
          font-size: 20px;
          content: '\e5ca';
          position: absolute;
          right: 15px; }
    .editor-wrapper .editor-toolbar .rdw-text-align-wrapper,
    .editor-wrapper .editor-toolbar .rdw-link-wrapper,
    .editor-wrapper .editor-toolbar .rdw-list-wrapper,
    .editor-wrapper .editor-toolbar .rdw-block-wrapper,
    .editor-wrapper .editor-toolbar .rdw-inline-wrapper {
      margin-bottom: 0; }
    .editor-wrapper .editor-toolbar .rdw-block-wrapper,
    .editor-wrapper .editor-toolbar .rdw-inline-wrapper {
      border-right: 1px solid white;
      border-right-color: rgba(255, 255, 255, 0.1); }
    .editor-wrapper .editor-toolbar .rdw-option-wrapper {
      width: 32px;
      height: 32px;
      border-radius: 5px;
      border: none;
      background-color: initial;
      color: white; }
      .editor-wrapper .editor-toolbar .rdw-option-wrapper.rdw-option-active {
        background-color: rgba(255, 255, 255, 0.2); }
      .editor-wrapper .editor-toolbar .rdw-option-wrapper:hover {
        background-color: rgba(255, 255, 255, 0.1); }
      .editor-wrapper .editor-toolbar .rdw-option-wrapper.rdw-option-active, .editor-wrapper .editor-toolbar .rdw-option-wrapper:hover {
        box-shadow: none; }
        .editor-wrapper .editor-toolbar .rdw-option-wrapper.rdw-option-active > img, .editor-wrapper .editor-toolbar .rdw-option-wrapper:hover > img {
          opacity: 1; }
      .editor-wrapper .editor-toolbar .rdw-option-wrapper > img {
        filter: invert(1);
        opacity: 0.8; }

label {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 12px;
  font-weight: 400; }

.form-control {
  display: block;
  width: 100%;
  height: 40px;
  padding: 10px 15px 9px 15px;
  font-size: 16px;
  line-height: 1.42857143;
  color: rgba(0, 34, 51, 0.8);
  border: none;
  border-radius: 5px;
  background-color: #fff;
  background-image: none;
  box-shadow: 0 0 0 1px rgba(0, 34, 51, 0.15);
  transition: 0.2s border-color ease;
  -webkit-appearance: none; }
  .form-control:focus, .form-control.focus {
    outline: none;
    box-shadow: 0 0 0 1px rgba(0, 34, 51, 0.3) !important; }
  .form-control:hover {
    outline: none; }
  .form-control::-ms-expand {
    border: 0;
    background-color: transparent; }
  .form-control::placeholder {
    color: rgba(0, 34, 51, 0.3); }
  .form-control[disabled],
  fieldset[disabled] .form-control {
    background-color: #f9f9f9;
    opacity: 1; }
  .form-control[disabled],
  fieldset[disabled] .form-control {
    cursor: not-allowed; }
  .form-control--noresize {
    resize: none; }
  .form-control--number {
    width: 100px; }
  .form-control--select {
    height: auto;
    min-height: 40px;
    padding: 2px;
    padding-right: 34px;
    font-size: 0;
    cursor: pointer; }
    .form-control--select:hover {
      box-shadow: 0 0 0 1px rgba(0, 34, 51, 0.2); }
      .form-control--select:hover .tag__arrow {
        color: rgba(0, 34, 51, 0.8); }
        .moonlight .form-control--select:hover .tag__arrow {
          color: #fff; }
    .form-control--select .tag {
      display: block;
      float: left; }
  .form-control--tags {
    position: relative;
    display: flex;
    height: auto;
    min-height: 40px;
    padding: 2px;
    font-size: 0;
    flex: 1 1 auto;
    flex-wrap: wrap;
    justify-content: flex-start; }
    .form-control--tags .tag {
      margin: 2px;
      flex: 0 0 auto; }
    .form-control--tags .form-control-clean {
      width: auto;
      height: 36px;
      margin: 0 2px;
      padding: 11px 5px 9px 10px;
      flex: 1 1 auto; }
  .form-control--textarea {
    min-height: 90px; }
  .form-control--secondary {
    min-width: 200px;
    color: rgba(0, 34, 51, 0.65);
    border: 1px solid rgba(0, 34, 51, 0.15);
    border-bottom-color: rgba(0, 34, 51, 0.2);
    background: linear-gradient(to bottom, #fcfcfc 0%, #f7f8f9 100%);
    background-clip: padding-box;
    box-shadow: 0 1px 1px rgba(0, 34, 51, 0.05);
    transition: none; }
    .form-control--secondary:focus, .form-control--secondary:focus:hover {
      border-color: rgba(0, 34, 51, 0.3);
      box-shadow: 0 1px 1px rgba(0, 34, 51, 0.05); }
    .form-control--secondary:active {
      box-shadow: inset 0 1px 2px rgba(0, 34, 51, 0.15); }
  .form-control--selected {
    padding-right: 70px; }
  .form-control.alpha-text-size {
    font-size: 2rem; }
  .form-control.delta-text-size {
    font-size: 1.4rem; }

textarea.form-control {
  height: auto; }

.help-block,
.help-text {
  display: block;
  margin-top: 8px;
  margin-bottom: 10px;
  font-size: 1.4rem;
  color: rgba(0, 34, 51, 0.5); }

.form-group {
  margin-bottom: 20px; }

.has-feedback {
  position: relative; }
  .has-feedback .form-control {
    padding-left: 50px; }

.form-control-feedback {
  position: absolute;
  top: 0;
  left: 6px;
  z-index: 2;
  display: block;
  width: 40px;
  height: 40px;
  line-height: 40px;
  color: rgba(0, 34, 51, 0.5);
  text-align: center;
  pointer-events: none; }
  .form-control-feedback .material-icons {
    line-height: inherit; }
  .form-control-feedback button {
    padding: 0;
    pointer-events: all; }
  .form-control-feedback.form-control-counter {
    font-size: 1.4rem;
    line-height: 38px;
    color: rgba(0, 34, 51, 0.3); }

.feedback-right .form-control {
  padding-right: 40px;
  padding-left: 14px; }

.feedback-right .form-control-feedback {
  right: 6px;
  left: auto; }

.feedback-right .form-control-clean {
  padding-left: 0; }

.feedback-right-text .form-control {
  padding-right: 110px; }

.feedback-right-text p.form-control-feedback {
  right: 14px;
  width: auto;
  max-width: none;
  margin: 0; }

.has-feedback--lg .form-control {
  padding-left: 80px; }

.has-feedback--lg .form-control-feedback {
  width: auto; }

.has-feedback--lg.feedback-right .form-control {
  padding-right: 80px;
  padding-left: 14px; }

.has-feedback--lg.feedback-right .form-control-feedback {
  right: 15px; }

.has-feedback label ~ .form-control-feedback {
  top: 34px; }

.has-feedback label.sr-only ~ .form-control-feedback {
  top: 0; }

.has-success .help-block,
.has-success .form-feedback > li,
.has-success .control-label,
.has-success .radio,
.has-success .checkbox,
.has-success .radio-inline,
.has-success .checkbox-inline,
.has-success.radio label,
.has-success.checkbox label,
.has-success.radio-inline label,
.has-success.checkbox-inline label {
  color: #4bc632; }

.has-success .form-control-feedback {
  color: #4bc632; }

.has-success .form-control {
  box-shadow: 0 0 0 1px #72D400 !important; }
  .has-success .form-control-clean {
    box-shadow: none; }

.has-error .help-block,
.has-error .form-feedback > li,
.has-error .control-label,
.has-error .radio,
.has-error .checkbox,
.has-error .radio-inline,
.has-error .checkbox-inline,
.has-error.radio label,
.has-error.checkbox label,
.has-error.radio-inline label,
.has-error.checkbox-inline label {
  color: #F25735; }

.has-error .form-control-feedback {
  color: #F25735; }

.has-error .form-control {
  box-shadow: 0 0 0 1px #F4562B !important; }
  .has-error .form-control-clean {
    box-shadow: none; }

.ReactCollapse--collapse {
  transition: height 500ms; }

.tooltip {
  position: absolute;
  z-index: 1080;
  display: block;
  visibility: visible;
  max-width: 225px;
  opacity: 1;
  font-family: "Source Sans Pro", arial;
  font-size: 1.6rem;
  font-weight: normal;
  font-style: normal;
  color: rgba(0, 34, 51, 0.8);
  text-align: left;
  text-align: start;
  white-space: normal;
  text-decoration: none;
  letter-spacing: normal;
  word-spacing: normal;
  text-transform: none;
  word-wrap: normal;
  word-break: normal;
  text-shadow: none;
  line-break: auto;
  font-size: 1.3rem; }

.tooltip-hidden {
  display: none; }

.tooltip-placement-top,
.tooltip-placement-topLeft,
.tooltip-placement-topRight {
  padding: 5px 0 9px 0; }
  .tooltip-placement-top .tooltip-arrow,
  .tooltip-placement-topLeft .tooltip-arrow,
  .tooltip-placement-topRight .tooltip-arrow {
    bottom: 4px;
    margin-left: -5px;
    border-width: 5px 5px 0;
    border-top-color: rgba(0, 34, 51, 0.8); }

.tooltip-inner {
  min-height: 30px;
  padding: 6px 10px;
  color: #fff;
  text-align: left;
  text-decoration: none;
  border-radius: 4px;
  background-color: rgba(0, 34, 51, 0.8);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
  word-break: break-word;
  width: max-content;
  max-width: 320px; }
  .text-center .tooltip-inner {
    text-align: center; }
  .text-left .tooltip-inner {
    text-align: left; }

.tooltip-arrow {
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  border-color: transparent; }

.tooltip-placement-top .tooltip-arrow {
  left: 50%; }

.tooltip-placement-topLeft .tooltip-arrow {
  left: 15%; }

.tooltip-placement-topRight .tooltip-arrow {
  right: 15%; }

@charset "UTF-8";
@font-face {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  src: url('https://d8ejoa1fys2rk.cloudfront.net/5.0.5/includes/fonts-licensed/SourceSansPro/SourceSansPro-Regular.eot');
  src:
    url('https://d8ejoa1fys2rk.cloudfront.net/5.0.5/includes/fonts-licensed/SourceSansPro/SourceSansPro-Regular.eot?#iefix')
      format('embedded-opentype'),
    url('https://d8ejoa1fys2rk.cloudfront.net/5.0.5/includes/fonts-licensed/SourceSansPro/SourceSansPro-Regular.woff2')
      format('woff2'),
    url('https://d8ejoa1fys2rk.cloudfront.net/5.0.5/includes/fonts-licensed/SourceSansPro/SourceSansPro-Regular.woff')
      format('woff'),
    url('https://d8ejoa1fys2rk.cloudfront.net/5.0.5/includes/fonts-licensed/SourceSansPro/SourceSansPro-Regular.ttf')
      format('truetype'),
    url('https://d8ejoa1fys2rk.cloudfront.net/5.0.5/includes/fonts-licensed/SourceSansPro/SourceSansPro-Regular.svg#SourceSansPro')
      format('svg');
}
@font-face {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 600;
  src: url('https://d8ejoa1fys2rk.cloudfront.net/5.0.5/includes/fonts-licensed/SourceSansPro/SourceSansPro-Semibold.eot');
  src:
    url('https://d8ejoa1fys2rk.cloudfront.net/5.0.5/includes/fonts-licensed/SourceSansPro/SourceSansPro-Semibold.eot?#iefix')
      format('embedded-opentype'),
    url('https://d8ejoa1fys2rk.cloudfront.net/5.0.5/includes/fonts-licensed/SourceSansPro/SourceSansPro-Semibold.woff2')
      format('woff2'),
    url('https://d8ejoa1fys2rk.cloudfront.net/5.0.5/includes/fonts-licensed/SourceSansPro/SourceSansPro-Semibold.woff')
      format('woff'),
    url('https://d8ejoa1fys2rk.cloudfront.net/5.0.5/includes/fonts-licensed/SourceSansPro/SourceSansPro-Semibold.ttf')
      format('truetype'),
    url('https://d8ejoa1fys2rk.cloudfront.net/5.0.5/includes/fonts-licensed/SourceSansPro/SourceSansPro-Semibold.svg#SourceSansPro')
      format('svg');
}

body {
  font-family: 'Source Sans Pro', SourceSansPro, sans-serif;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
`;
